<template>
  <v-card class="call-pop-op-content" v-if="state">
    <div
      class="header-pop-op"
      :class="isDark ? 'bg-background' : 'bg-infoLightest'"
    >
      <div class="text-right pt-6 pe-4">
        <v-icon
          icon="mdi-window-close"
          class="cursor-pointer pa-1"
          color="grey5"
          @click="emit('close')"
        ></v-icon>
      </div>
      <div class="accept-content mt-4">
        <v-icon
          icon="solar:phone-calling-rounded-bold"
          size="x-large"
          color="info7"
          class="call-animation"
        ></v-icon>
      </div>
    </div>

    <div v-if="!callerInfo.name">
      <div class="call-info mx-8 pt-12 pb-8">
        <span class="text-grey200 mt-4">{{ callerInfo.phoneNumber }}</span>
        <div class="text-grey4 mt-8">
          {{ $t("Calling") }}
        </div>
      </div>
      <v-divider class="mx-8" />
      <div class="options mx-8">
        <base-button
          @click="openFormModal()"
          name="Add New Person"
          prepend-icon="solar:user-rounded-outline"
        />
        <base-button
          @click="openFormModal('companies')"
          name="Add New Company"
          prepend-icon="solar:buildings-outline"
          color="success"
        />
      </div>
    </div>

    <div v-else>
      <div class="call-info mx-8">
        <div class="mb-4 mt-8">
          <v-badge location="bottom start" offset-y="10" dot color="success">
            <v-avatar size="large" @click="goToProfile()" class="cursor-pointer">
              <img
                :src="callerInfo.avatar ? callerInfo.avatar : UserImage"
                alt="user"
                width="54"
              />
            </v-avatar>
          </v-badge>
        </div>

        <div class="text-grey200 cursor-pointer text-h5" @click="goToProfile()">{{ callerInfo.name }}</div>
        <div class="text-grey200 cursor-pointer" @click="goToProfile()">{{ callerInfo.phoneNumber }}</div>
        <div class="text-grey4 my-6">
          {{ $t("Calling") }}
        </div>
        <v-divider class="mx-auto w-50" />
      </div>
      <div class="text-center my-4">
        <base-button
          @click="openCallReasonModal()"
          name="Add Call Reason"
          prepend-icon="solar:buildings-outline"
          color="success"
        />
      </div>
    </div>
  </v-card>
  <contact-add-modal
    :isOpen="isOpneAddForm"
    :type="type"
    @close="closeFormModal()"
  />
  <contact-call-reason
    :isOpen="isOpneAddReason"
    @close="closeCallReasonModal()"
  />
</template>

<script setup>
import UserImage from "/images/profile/user6.jpg";
import { useContactCallStore } from "~/stores/contact/call";
import { isDark } from "~/utils/UpdateColors";

const contactCallStore = useContactCallStore();

const emit = defineEmits(["close"]);

const props = defineProps({
  state: {
    type: Boolean,
    default: false,
  },
});

const callerInfo = computed(() => contactCallStore.callerInfo);

const isOpneAddForm = ref(false);
const isOpneAddReason = ref(false);
const type = ref(null);

const openFormModal = (formType = "people") => {
  type.value = formType;
  isOpneAddForm.value = true;
  emit("close");
};
const closeFormModal = () => {
  type.value = null;
  isOpneAddForm.value = false;
};
const openCallReasonModal = () => {
  isOpneAddReason.value = true;
  emit("close");
};
const closeCallReasonModal = () => {
  isOpneAddReason.value = false;
};

const goToProfile = () => {
  const url = `/contacts/${
    callerInfo.value.form_type === "people" ? "people" : "company"
  }/${callerInfo.value.contact_id}`;
  window.open(url, "_blank");
};
</script>

<style scoped lang="scss">
.call-pop-op-content {
  .border {
    border: 1px solid #d6d3d3;
  }
  overflow: hidden;
  width: 480px;
  position: fixed;
  z-index: 9999;
  bottom: 0;
  left: 0;
  margin-bottom: 20px;
  margin-left: 20px;
  border-radius: 24px;
  animation: 0.5s fade;
  .header-pop-op {
    height: 170px;
    // mask-image: url("/images/backgrounds/half-circle.svg");
    // mask-size: contain;
    // mask-repeat: no-repeat;
    // mask-position: center;
    border-radius: 0 0 50% 50% / 20% 20% 70% 70%;
  }
  .accept-content {
    background: rgb(var(--v-theme-info4));
    width: 60px;
    height: 60px;
    margin: auto;
    border-radius: 100%;
    border: solid 5px rgb(var(--v-theme-info4));
    animation: play 2s ease infinite;
    display: flex;
    justify-content: center;
    align-items: center;
    .call-animation {
      // animation: 0.5s call infinite;
    }
  }

  .call-info {
    text-align: center;
    span {
      font-size: 22px;
      font-weight: 700;
    }
    .title {
      font-size: 16px;
      font-weight: 600;
      color: #0066ff;
      padding: 5px 10px;
    }
    .phone {
      font-size: 18px;
      font-weight: 600;
      color: #2a2a2acd;
      padding: 5px 10px;
    }
  }
  .options {
    display: flex;
    justify-content: space-between;
    margin: 20px auto;
    animation: 1.5s bottomToTop;
  }
}

.close {
  animation: 0.2s slid-right;
}

@keyframes bottomToTop {
  0% {
    margin-top: 200px;
  }
  100% {
    margin-top: 40px;
  }
}

@keyframes fade {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes slid-right {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(100%);
  }
}

@keyframes call {
  0% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(12deg);
  }
  50% {
    transform: rotate(0eg);
  }
  75% {
    transform: rotate(-12deg);
  }
  100% {
    transform: rotate(0deg);
  }
}

@keyframes slid {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(0);
  }
}

@keyframes play {
  0% {
    transform: scale(1);
  }
  15% {
    box-shadow: 0 0 0 5px rgb(var(--v-theme-info3));
  }
  25% {
    box-shadow: 0 0 0 10px rgb(var(--v-theme-info2)),
      0 0 0 20px rgb(var(--v-theme-info1));
  }
  25% {
    box-shadow: 0 0 0 15px rgb(var(--v-theme-info2)),
      0 0 0 30px rgb(var(--v-theme-info1));
  }
}
</style>
